import { Dictionary, IdSelector } from '@ngrx/entity';

export function toDictionary<T extends object>(
  objects: T[],
  selector: IdSelector<T>,
): Dictionary<T> {
  return objects.reduce<Dictionary<T>>((dict, item, index) => {
    dict[selector(item)] = item;
    return dict;
  }, {});
}
